<app-header [pageType]="'iDesign'" ></app-header>

<div class="why-iquanta-modals get-counselling-form">
    <div class="modal" id="ChooseEquiry" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered px-2">
      <div class="modal-content  p-2">
       <div class="modal-body p-0">
        <div data-dismiss="modal" class="close-button position-absolute">
         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28" fill="none">
          <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
          <path d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z" fill="#1E1515" />
         </svg>
        </div>
        <div class="modal-body-wrapper">
         <div class="d-flex gap-2">
          <div class="counselling-form px-2 py-3">
           <div class="text-center mb-3">
            <h5 class="f-medium mb-2">Get Counselling & free Resources</h5>
           </div>
           <form [formGroup]="counsellingForm" class="p-3">
            <div class="row">
             <div class="col-md-6 pr-sm-1">
              <div class="form-group">
               <label class="f-light mb-2 text-uppercase">Name</label>
               <input placeholder="Enter your name" autocomplete="off" formControlName="name" type="text" class="form-control f-light">
              </div>
             </div>
             <div class="col-md-6 pl-sm-1">
              <div class="form-group">
               <label class="f-light mb-2 text-uppercase">Number</label>
               <input placeholder="Enter your number" autocomplete="off" type="text" formControlName="mobile" class="form-control">
              </div>
             </div>
             <div class="col-md-12">
              <div class="form-group">
               <label class="f-light mb-2 text-uppercase">Email</label>
               <input placeholder="Enter your email" autocomplete="off" type="text" formControlName="email" class="form-control">
              </div>
             </div>
             <div class="col-md-12">
              <div class="form-group">
               <label class="f-light mb-2 text-uppercase">Exam </label>
               <select class="form-select" id="validationCustom04"  formControlName="course" required>
                <option selected disabled value="">Select...</option>
                  <option value="NID">NID</option>
                  <option value="IIT-UCEED">IIT-UCEED</option>
                  <option value="IIT-CEED">IIT-CEED</option>
                  <option value="NIFT">NIFT </option>
                  <option value="B.Arch">B.Arch </option>
              </select>
              </div>
             </div>
             <div class="col-md-12">
              <div class="header-actions d-flex align-items-end h-100">
               <button (click)="submit('Course Enquiry')" class="btn d-flex align-item-center justify-content-center btn_bg text-uppercase w-100">Submit</button>
              </div>
             </div>
            </div>
           </form>
          </div>
          <div class="mobile-card d-none d-sm-block py-4 px-4">
           <img class="img-fluid " src="https://media.iquanta.in/ui_images/idesign-nid.webp" alt="Get counselling & free resources">
          </div>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
</div>

<div class="design-banner">
    <div class="banner-elements">
        <img src="https://media.iquanta.in/ui_images/idesign/idesign-bg-pattern.webp" alt="">
    </div>
    <div class="container">
        <div class="row align-items-center mobile-row">
            <div class="col-md-7">
                <div class="bannner-content">
                    <h1>India's Best Design Online Course​</h1>
                        <p>iQuanta is the one stop solution for the best design online course for NID, NIFT, IIT-UCEED, IIT-CEED, NATA, and IIT-B.Arch in India. With more than 850+ students who have successfully cracked these top most design exams, iDesign provides expert guidance, personalised mentorship, 24*7 doubt solving, dual pedagogy (live + application classes), relevant content and many more. So your dream to pursue your passion for a design career begins here.</p>
                        <div class="home-btns">
                            <ul>
                                <li><button type="button" class="btn " (click)="gotosection('courses')">Design Packages </button></li>
                                <li> <button type="button" class="btn" data-toggle="modal" data-target="#ChooseEquiry">Course Enquiry </button></li>
                            </ul>
                        </div>
                </div>
            </div>
            <div class="col-md-5">
                <div class="banner-slide">
                    <div id="carouselExampleFade" class="carousel slide carousel-fade" data-ride="carousel" data-interval="3000" data-touch="true">
                        <div class="carousel-inner">
                          <div class="carousel-item active">
                            <img src="https://media.iquanta.in/ui_images/idesign/idesign-banner-topper-1.webp" class="d-block w-100" alt="...">
                          </div>
                          <div class="carousel-item">
                            <img src="https://media.iquanta.in/ui_images/idesign/idesign-banner-topper-2.webp" class="d-block w-100" alt="...">
                          </div>
                          <div class="carousel-item">
                            <img src="https://media.iquanta.in/ui_images/idesign/idesign-banner-topper-3.webp" class="d-block w-100" alt="...">
                          </div>
                          <div class="carousel-item">
                            <img src="https://media.iquanta.in/ui_images/idesign/idesign-banner-topper-4.webp" class="d-block w-100" alt="...">
                          </div>
                        </div>
                      </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="about">
    <div class="container">
            <div class="about-box">
                <div class="row">
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-5">
                                <div class="about-img">
                                    <img src="https://media.iquanta.in/ui_images/idesign/idesign-faculty-2.webp" alt="">
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="about-wrapper">
                                    <h2>About</h2>
                                    <p>At iQuanta we are committed to turning our students' dreams into reality and help them crack the exam with flying colours. With the help of our quality content, dual pedagogy teaching approach wherein we have a unique approach of live + application classes, 24*7 doubt solving and personalised mentorship our design course have a proven track record of success rate. Our students have been toppers in design exams such as NID, NIFT, IIT-UCEED, IIT-CEED, NATA, and IIT-B.Arch.</p>
                                    <div class="points">
                                        <ul>
                                            <li>
                                                <h3>6</h3>
                                                <p>Courses</p>
                                            </li>
                                            <li>
                                                <h3>850</h3>
                                                <p>SELECTIONS +</p>
                                            </li>
                                            <li>
                                                <h3>1,600</h3>
                                                <p>STUDENTS</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                            <div class="form-wrapper">
                                <h5>Start your  Journey Today!</h5>
                                <form [formGroup]="counsellingForm" class="row g-3 ">
                                  <div class="col-md-12">
                                    <!-- <label for="validationCustom01" class="form-label">Full Name</label> -->
                                    <input autocomplete="off" type="text" class="form-control" id="validationCustom01" placeholder="Enter Full Name" formControlName="name" required>
                                  </div>
                                  <div class="col-md-12">
                                    <!-- <label for="validationCustom02" class="form-label">Email</label> -->
                                    <input autocomplete="off" type="text" class="form-control" id="validationCustom02" placeholder="Enter Email" formControlName="email" required>
                                  </div>
                    
                                  <div class="col-md-12">
                                    <!-- <label for="validationCustom03" class="form-label">Phone Number</label> -->
                                    <input autocomplete="off" type="text" class="form-control" id="validationCustom03" placeholder="Phone Number" formControlName="mobile" required>
                                  </div>
                                  <div class="col-md-12">
                                    <!-- <label for="validationCustom04" class="form-label">Experience </label> -->
                                    <select class="form-select" id="validationCustom04"  formControlName="course" required>
                                      <option selected disabled value="">Select...</option>
                                        <option value="NID">NID</option>
                                        <option value="IIT-UCEED">IIT-UCEED</option>
                                        <option value="IIT-CEED">IIT-CEED</option>
                                        <option value="NIFT">NIFT </option>
                                        <option value="B.Arch">B.Arch </option>
                                    </select>
                                  </div>
                                  <div class="col-12">
                                    <button (click)="submit('')" class="btn submit-btn"  type="submit">Submit </button>
                                  </div>
                                </form>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</div>

<div class="courses-wrappers">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="head">
                    <h2>Explore iDesign Courses</h2>
                </div>
            </div>
        </div>
        <div class="courses-btns">
            <ul>
                <li [routerLink]="'/idesign/uceed'">
                    <div class="icon">
                        <img src="https://media.iquanta.in/ui_images/idesign/uceed-icon.webp" alt="">
                    </div>
                    <h6>UCEED <br> Online Coaching</h6>

                    <div class="link">
                        <i class="bi bi-arrow-up-right"></i>
                    </div>
                </li>
                <li [routerLink]="'/idesign/ceed'">
                    <div class="icon">
                        <img src="https://media.iquanta.in/ui_images/idesign/ceed-icon.webp" alt="">
                    </div>
                    <h6>CEED <br>Online Coaching</h6>

                    <div class="link">
                        <i class="bi bi-arrow-up-right"></i>
                    </div>
                </li>
                <li [routerLink]="'/idesign/nid'">
                    <div class="icon">
                        <img src="https://media.iquanta.in/ui_images/idesign/nid-icon.webp" alt="">
                    </div>
                    <h6>NID <br> Online Coaching</h6>

                    <div class="link">
                        <i class="bi bi-arrow-up-right"></i>
                    </div>
                </li>
                <li [routerLink]="'/idesign/barch'">
                    <div class="icon">
                        <img src="https://media.iquanta.in/ui_images/idesign/nata-icon.webp" alt="">
                    </div>
                    <h6>B.arch <br> Online Coaching</h6>

                    <div class="link">
                        <i class="bi bi-arrow-up-right"></i>
                    </div>
                </li>
                <li [routerLink]="'/idesign/nift'">
                    <div class="icon">
                        <img src="https://media.iquanta.in/ui_images/idesign/nift-icon.webp" alt="">
                    </div>
                    <h6>NIFT <br>Online Coaching</h6>

                    <div class="link">
                        <i class="bi bi-arrow-up-right"></i>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>


<div class="why">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="head">
                    <h2>Why iQuanta is Best? </h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="why-box">
                    <h3>Relevant and Latest Study Material</h3>
                    <p>We provide the most relevant and updated study material. Each of our modules are customised as per the specific exam so that you study and prepare from the right material. Our design course is in alignment with the latest exam pattern and is the most comprehensive product for preparation.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="why-box">
                    <h3>24*7 Doubt Solving</h3>
                    <p>Our students can get their doubts solved anytime, be it early in the morning or late midnight. Any time you shoot a doubt we will instantly solve them within a few minutes.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="why-box">
                    <h3>Dual Pedagogy (Live + Application Classes)
                    </h3>
                    <p>The dual pedagogy teaching style is a unique approach of teaching adopted by iQuanta. At the first stage - live classes; we teach all the basic concept and then in the application classes you have to apply the learnt concepts to questions that will help you learn effectively.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="our-results" id="results">
    <div class="container">
     <div class="row justify-content-center">
      <div class="col-md-8">
       <div class="section-header">
        <h2>Our Top Performers</h2>
       </div>
      </div>
     </div>
     <div class="row justify-content-center">
      <div class="col-md-12">
       <div class="results-tab">
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
         <li class="nav-item" role="presentation">
          <button class="nav-link active" id="pills-NID-tab" data-toggle="pill" data-target="#pills-NID" type="button" role="tab" aria-controls="pills-NID" aria-selected="true">NID</button>
         </li>
         <li class="nav-item" role="presentation">
          <button class="nav-link" id="pills-UCEED-tab" data-toggle="pill" data-target="#pills-UCEED" type="button" role="tab" aria-controls="pills-UCEED" aria-selected="false">IIT-UCEED</button>
         </li>
         <li class="nav-item" role="presentation">
          <button class="nav-link" id="pills-CEED-tab" data-toggle="pill" data-target="#pills-CEED" type="button" role="tab" aria-controls="pills-CEED" aria-selected="false">IIT-CEED</button>
         </li>
         <li class="nav-item" role="presentation">
          <button class="nav-link" id="pills-NIFT-tab" data-toggle="pill" data-target="#pills-NIFT" type="button" role="tab" aria-controls="pills-NIFT" aria-selected="false">NIFT</button>
         </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
         <div class="tab-pane fade show active" id="pills-NID" role="tabpanel" aria-labelledby="pills-NID-tab" tabindex="0">
          <div class="results-section">
           <div class="toper_tab_imgs">
            <ul>
             <li *ngFor="let topper of NID">
              <img src="{{topper.img}}" alt="iQuanta JEE Toppers">
             </li>
            </ul>
           </div>
          </div>
         </div>
         <div class="tab-pane fade" id="pills-UCEED" role="tabpanel" aria-labelledby="pills-UCEED-tab" tabindex="0">
          <div class="results-section">
            <div class="toper_tab_imgs">
                <ul>
                 <li *ngFor="let topper of UCEED">
                  <img src="{{topper.img}}" alt="iQuanta JEE Toppers">
                 </li>
                </ul>
               </div>
          </div>
         </div>
         <div class="tab-pane fade" id="pills-CEED" role="tabpanel" aria-labelledby="pills-CEED-tab" tabindex="0">
          <div class="results-section">
           <div class="toper_tab_imgs">
            <ul>
             <li *ngFor="let topper of CEED">
              <img src="{{topper.img}}" alt="iQuanta JEE Toppers">
             </li>
            </ul>
           </div>
          </div>
         </div>
         <div class="tab-pane fade" id="pills-NIFT" role="tabpanel" aria-labelledby="pills-NIFT-tab" tabindex="0">
          <div class="results-section">
           <div class="toper_tab_imgs">
            <ul>
             <li *ngFor="let topper of NIFT">
              <img src="{{topper.img}}" alt="iQuanta JEE Toppers">
             </li>
            </ul>
           </div>
          </div>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
</div> -->

<div class="results-wrapper">
    <div class="container">
        <!-- <div class="row">
            <div class="col-md-12">
                <div class="head">
                    <h2>Our Top Performers</h2>
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-md-6">
                <div class="results-section">
                    <h3>NID TOP PERFORMERS​</h3>
                    <div class="infinite-marquee">
                        <swiper [config]="config" class="image-marquee">
                            <ng-template swiperSlide *ngFor="let item of NID">
                              <img [src]="item.img" alt="top performer" />
                            </ng-template>
                          </swiper>
                      </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="results-section">
                    <h3>IIT-UCEED TOP PERFORMERS​</h3>
                    <div class="infinite-marquee">
                        <swiper [config]="config" class="image-marquee">
                            <ng-template swiperSlide *ngFor="let item of UCEED">
                              <img [src]="item.img" alt="top performer" />
                            </ng-template>
                          </swiper>
                      </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="results-section">
                    <h3>IIT- CEED TOP PERFORMERS​</h3>
                    <div class="infinite-marquee">
                        <swiper [config]="config" class="image-marquee">
                            <ng-template swiperSlide *ngFor="let item of CEED">
                              <img [src]="item.img" alt="top performer" />
                            </ng-template>
                          </swiper>
                      </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="results-section">
                    <h3>NIFT TOP PERFORMERS​</h3>
                    <div class="infinite-marquee">
                        <swiper [config]="config" class="image-marquee">
                            <ng-template swiperSlide *ngFor="let item of NIFT">
                              <img [src]="item.img" alt="top performer" />
                            </ng-template>
                          </swiper>
                      </div>
                </div>
            </div>

        </div>
    </div>
</div>

<div class=" courses-section" id="courses">
    <div class="container">
     <div class="row">
      <div class="col-md-12">
       <div class="section-header ">
        <h2 >iDesign Online Course Packages</h2>
       </div>
      </div>
     </div>
     <div class="row mx-md-0 courserow justify-content-center">
      <div *ngFor="let course of coursesArray" class="col-md-4">
       <app-course-card-home [course]="course" [pageName]="'iDesign'"></app-course-card-home>
      </div>
     </div>
    </div>
</div>

<div class="collages">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="head">
                    <h2>Esteemed Design Institutions</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="collage-wrapper">
                <ul>
                    <li *ngFor="let collages of collageList">
                        <img src="{{collages.image}}" alt="collage" />
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="main-section same-questions faculty-section  pt-0" id="faculty">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="img same-questions-wrapper">
                    <img style="border-radius: 28px;" class="img-fluid d-none d-sm-block" loading="lazy"
                        src="https://media.iquanta.in/ui_images/idesign/new-idesign-teachers.webp" alt="iDesign Coaching">
                    <img style="border-radius: 28px;" class="img-fluid d-block d-sm-none" loading="lazy"
                        src="https://media.iquanta.in/ui_images/idesign/new-idesign-teachers.webp" alt="iDesign Coaching">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="main-section faculty-section pt-0">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="atf-slider-component our-faculties px-sm-5 pt-sm-5 pb-sm-3">
                    <div class="faculties-top d-flex justify-content-between">
                        <div class="faculties-top-col-1 ">
                            <div class="home-hero-heading f-bold mb-3">Know your Faculties</div>
                            <h6 class="f-light mb-0">Know about the top design mentor at iQuanta Design coaching.</h6>
                        </div>
                        <div class="faculties-top-col-2 d-flex justify-content-center align-items-center">
                            <div class="swiper is-lottie w-dyn-list">
                                <div role="list" class="swiper-wrapper is-lottie w-dyn-items">
                                    <div role="listitem" class="swiper-slide is-lottie w-dyn-item">
                                        <div class="swiper-lottie-embed w-richtext">
                                            <div class="w-embed">
                                                <div class="credential-text">
                                                    <h3><span>Priyank Soni Sir</span></h3>
                                                    <h4>An exceptional educator with over <span>15 years</span> of rich teaching experience</h4>
                                                    <h5>Priyank Soni is an alumnus of <span>IIT Hyderabad and IIM Ahmedabad</span>. Known for his dynamic teaching style and deep subject knowledge, he has <span>mentored thousands of students</span> towards success in competitive exams. With a unique blend of technical and managerial expertise, he simplifies complex concepts and inspires students to achieve their academic goals.</h5>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                    <div role="listitem" class="swiper-slide is-lottie w-dyn-item">
                                        <div class="swiper-lottie-embed w-richtext">
                                            <div class="w-embed">
                                                <div class="credential-text">
                                                    <h3><span>Mayank Soni Sir</span></h3>
                                                    <h4>With a stellar academic journey and over a decade of teaching expertise, Mayank Soni is an exceptional mentor in the field of design. An alumnus of <span>NID Gandhinagar</span> and Leeds <span>Metropolitan University, London (UK)</span>, he brings global perspective and practical insights into the classroom.</h4>
                                                    <h5>With <span>10+ years</span> of experience, he is deeply committed to nurturing creativity, design thinking, and innovation in his students, making learning both inspiring and impactful.</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="listitem" class="swiper-slide is-lottie w-dyn-item">
                                        <div class="swiper-lottie-embed w-richtext">
                                            <div class="w-embed">
                                                <div class="credential-text">
                                                    <h3><span>Surbhi Bajaj Ma’am</span></h3>
                                                    <h4>A passionate visual artist and seasoned educator, Surbhi Bajaj brings a wealth of knowledge and global experience to the table. She is <span>UGC NET</span> Qualified for Assistant Professor in Visual Arts and has honed her craft at <span>the Florence Art Academy, Italy</span> </h4>
                                                    <h5>the <span>Samsara Academy of Art, Hyderabad</span>. With<span> 9+ years</span> of teaching experience, she is known for her strong academic foundation and artistic mentorship that inspires students to explore and express their creativity at a deeper level.</h5>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                    <div role="listitem" class="swiper-slide is-lottie w-dyn-item">
                                        <div class="swiper-lottie-embed w-richtext">
                                            <div class="w-embed">
                                                <div class="credential-text">
                                                    <h3><span>Gaurav Khatri Sir</span></h3>
                                                    <h4>An experienced design educator and mentor, Gaurav Khatri is a proud <span>alumnus of NIFT Mumbai</span>.</h4>
                                                    <h5>With over <span> 8 years</span> of teaching experience, he brings a deep understanding of design principles combined with a practical approach to learning. His calm and insightful teaching style helps students build strong fundamentals and creative confidence, making him a favorite among design aspirants.</h5>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                   
                                    <div role="listitem" class="swiper-slide is-lottie w-dyn-item">
                                        <div class="swiper-lottie-embed w-richtext">
                                            <div class="w-embed">
                                                <div class="credential-text">
                                                    <h3><span>Nayan Mondal Sir</span></h3>
                                                    <h4>A creative powerhouse and inspiring mentor, Nayan Mondal is an <span>alumnus of NIFT Delhi and NID Madhya Pradesh.</span></h4>
                                                    <h5>With over <span>5 years</span> of teaching experience, he blends practical insights with deep design knowledge, making learning both engaging and effective. Known for his friendly approach and innovative teaching methods, he helps students unlock their full creative potential and excel in the world of <span>design and fashion</span>.</h5>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                    <div role="listitem" class="swiper-slide is-lottie w-dyn-item">
                                        <div class="swiper-lottie-embed w-richtext">
                                            <div class="w-embed">
                                                <div class="credential-text">
                                                    <h3><span>Shaily Tirkey Ma'am</span></h3>
                                                    <h4>A passionate educator and creative mentor, Shaily Tirkey is a graduate of <span> NIFT Gandhinagar</span> and pursued further studies at Coventry <span>University, London.</span></h4>
                                                    <h5>With over <span>5 years</span> of teaching experience, she brings a global perspective and an artistic flair to her classes. Her energy, innovative approach, and student-first attitude make her a favorite among learners aspiring to build a strong foundation in design and creative fields.</h5>
                                                </div>
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="home-hero-bottom">
                        <div class="swiper is-head-controls w-dyn-list">
                         <div role="list" class="swiper-wrapper is-head-controls w-dyn-items">
                          <div role="listitem" class="swiper-slide is-head-controls w-dyn-item">
                           <div style="background-color:#edffa4" class="atf-person-wrapper">
                            <img src="https://media.iquanta.in/ui_images/idesign/idesign-faculty-1.webp" loading="lazy" alt="iQuanta Faculty" sizes="(max-width: 1919px) 11vw, 180px" class="person-img" />
                           </div>
                          </div>
                          <div role="listitem" class="swiper-slide is-head-controls w-dyn-item">
                            <div style="background-color:#26443f" class="atf-person-wrapper">
                             <img src="https://media.iquanta.in/ui_images/idesign/idesign-faculty-2.webp" loading="lazy" alt="iQuanta Faculty" sizes="(max-width: 1919px) 11vw, 180px" class="person-img" />
                            </div>
                           </div>
                          <div role="listitem" class="swiper-slide is-head-controls w-dyn-item">
                           <div style="background-color:#26443f" class="atf-person-wrapper">
                            <img src="https://media.iquanta.in/ui_images/idesign/idesign-faculty-3.webp" loading="lazy" alt="iQuanta Faculty" sizes="(max-width: 1919px) 11vw, 180px" class="person-img" />
                           </div>
                          </div>
                          <div role="listitem" class="swiper-slide is-head-controls w-dyn-item">
                           <div style="background-color:#836f69" class="atf-person-wrapper">
                            <img class="img-fluid" src="https://media.iquanta.in/ui_images/idesign/idesign-faculty-4.webp" loading="lazy" alt="iQuanta Faculty" class="person-img" />
                           </div>
                          </div>
                       
                          <div role="listitem" class="swiper-slide is-head-controls w-dyn-item">
                           <div style="background-color:#edffa4" class="atf-person-wrapper">
                            <img class="img-fluid" src="https://media.iquanta.in/ui_images/idesign/idesign-faculty-5.webp" loading="lazy" alt="iQuanta Faculty" class="person-img" />
                           </div>
                          </div>
                          <div role="listitem" class="swiper-slide is-head-controls w-dyn-item">
                           <div style="background-color:#26443f" class="atf-person-wrapper">
                            <img class="img-fluid" src="https://media.iquanta.in/ui_images/idesign/idesign-faculty-6.webp" loading="lazy" alt="iQuanta Faculty" class="person-img" />
                           </div>
                          </div>
                         </div>
                        </div>
                       </div>
                </div>
            </div>

        </div>
    </div>


</div>

<div class="main-section faq-section pt-4">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10 px-2">

                <div class="faq-card">
                    <div class="row">
                        <div class="col-md-12">
                            <h2 class="mb-0 text-center f-bold">Frequently Asked Questions</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="accordion mt-3" id="accordionExample1">
                                <div class="card">
                                    <div class="card-header" id="headingSix">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapseSix" aria-expanded="false"
                                                aria-controls="collapseFour">
                                                Which is the best design course for preparation?
                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapseSix" class="collapse" aria-labelledby="headingSix"
                                        data-parent="#accordionExample1">
                                        <div class="card-body">
                                            <p class="f-light">iQuanta design course is the best design course for your preparation. It has some unique features such as 24*7 doubt solving, latest and relevant content, dual pedagogy approach, personalised mentorship from experts are some of the unique features of the design course offered by iQuanta.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingSeven">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapseSeven"
                                                aria-expanded="false" aria-controls="collapseFour">
                                                What features are important to choose the best design online coaching?
                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven"
                                        data-parent="#accordionExample1">
                                        <div class="card-body">
                                            <p class="f-light">As you have a plethora of options for choosing design online course but not all of them are the right one or have the relevant content. So you should carefully consider some important factors before choosing the right design online coaching such as the content quality, the mentorship and guidance you would get during your preparation journey, instant doubt solving functionality, instant doubt solving, etc.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingEight">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapseEight"
                                                aria-expanded="false" aria-controls="collapseFour">
                                                Does any design coaching provide instant doubt solving?
                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapseEight" class="collapse" aria-labelledby="headingEight"
                                        data-parent="#accordionExample1">
                                        <div class="card-body">
                                            <p class="f-light">Yes, iQuanta design course provides instant doubt solving functionality. So during your preparation you can get your doubts solved immediately so that the pace of your preparation does not slow down. </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingNine">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapseNine" aria-expanded="false"
                                                aria-controls="collapseFour">
                                                Which is the top design entrance exam in India?
                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapseNine" class="collapse" aria-labelledby="headingNine"
                                        data-parent="#accordionExample1">
                                        <div class="card-body">
                                            <p class="f-light">Some of the top design entrance exam in India are NIFT, UCEED and IIT JEE B.Arch.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingTen">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapseTen" aria-expanded="false"
                                                aria-controls="collapseFour">
                                                What is the NIFT exam date?
                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapseTen" class="collapse" aria-labelledby="headingTen"
                                        data-parent="#accordionExample1">
                                        <div class="card-body">
                                            <p class="f-light">NIFT exam is usually conducted in the month of February and candidates who are of 24 year of age and have passed class 12 from a recognised board are eligible for this exam.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingFive">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapseFive" aria-expanded="false"
                                                aria-controls="collapseFour">
                                                What is IIT UCEED?

                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapseFive" class="collapse" aria-labelledby="headingFive"
                                        data-parent="#accordionExample1">
                                        <div class="card-body">
                                            <p class="f-light">Undergraduate Common Entrance Exam for Design or UCEED is a national level design entrance exam that is conducted by IIT Bombay for admission to the design courses at the UG level at the IITs. It is a 3 hour computer based test.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingsix">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapsesix" aria-expanded="false"
                                                aria-controls="collapsesix">
                                                What is the eligibility for IIT B.Arch exam?
                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapsesix" class="collapse" aria-labelledby="headingsix"
                                        data-parent="#accordionExample1">
                                        <div class="card-body">
                                            <p class="f-light">In order to be eligible for IIT BArch exam candidates must have passed class 12 with a minimum of 50% marks in aggregate and the exam is of three hours and has three sections in total.</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingSeven">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left collapsed" type="button"
                                                data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false"
                                                aria-controls="collapseSeven">
                                                What are the top colleges for design?
                                            </button>
                                        </h2>
                                    </div>
                                    <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven"
                                        data-parent="#accordionExample1">
                                        <div class="card-body">
                                            <p class="f-light">Top colleges for design are National Institute of Design, NIFT and IITs offering design courses.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<app-footer [hideBarFlag]="true"></app-footer>

